<template>
  <article class="event" :class="(event.userList.length === 0 && 'event--is-empty')">
    <header class="event__header">
      <span class="event__emoji" v-if="event.userList.length === 0">👻</span>
      <span class="event__emoji" v-if="event.userList.length === 1">🙂</span>
      <span class="event__emoji" v-if="event.userList.length === 2">😄</span>
      <span class="event__emoji" v-if="event.userList.length >= 3">🎉</span>
      <strong class="event__date">{{date}}</strong>
    </header>
    <ul class="event__participant-list">
      <li class="participant" v-for="participant in event.userList">@{{participant}}</li>
    </ul>
    <footer class="event__footer">
      <button
        class="event__enter"
        @click="enterSlot(event.id)"
        v-if="!isParticipating"
      >Mich Hinzufügen</button>
      <button class="event__leave" @click="leaveSlot(event.id)" v-else>Mich Entfernen</button>
      <button
        class="event__remove"
        @click="removeSlot(event.id)"
        v-if="event.userList.length === 0"
      >Slot Löschen</button>
    </footer>
  </article>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
export default {
  props: ["event"],
  computed: {
    date() {
      return moment(this.event.start).format("DD.MM HH:mm");
    },
    isParticipating() {
      return this.event.userList.includes(this.username);
    },
    ...mapGetters(["username"])
  },
  methods: {
    ...mapActions(["enterSlot", "leaveSlot", "removeSlot"])
  }
};
</script>

<style>
.event {
  display: block;
  width: 100%;
  padding: 0.5rem;
}
.event--is-empty .event__date {
  background-color: #ff9;
}
.event__footer,
.event__header {
  display: inline-block;
}
.event__date {
  margin-right: 0.2em;
}
.event__participant-list {
  display: inline;
  list-style-type: none;
  padding: 0;
}
.event__leave,
.event__remove,
.event__enter {
  font-size: inherit;
  background-color: #eeffee;
  line-height: inherit;
  letter-spacing: inherit;
  font-family: inherit;
  border: 0;
  padding: 0;
  cursor: pointer;
  margin-right: 0.2em;
  /* opacity: 0.2; */
  transition: opacity 0.2s 0.5s;
}
.event__emoji {
  margin-right: 0.4em;
}
.event__enter:hover {
  background-color: #99ff99;
}
.event:hover .event__remove,
.event:hover .event__leave,
.event:hover .event__enter {
  transition: opacity 0.2s 0s;
  opacity: 1;
}
.event__leave {
  background-color: #ffeeee;
}
.event__leave:hover {
  background-color: #ff9999;
}
.event__remove {
  background-color: #ffeeee;
}
.event__remove:hover {
  background-color: #ff9999;
}
.participant {
  display: inline;
  margin-right: 0.2em;
}
</style>
